export default {
  UPDATE_CHAT_ROOM_COUNT: 'update-chat-room-count', // 상담방 상태가 변경될때 카운트 수정을 위해 호출한다
  UPDATE_ALL_STATUS_COUNT: 'update-all-status-count', // 전체 보기 상담방 카운트 up
  UPDATE_CHAT_ROOM_CUSTOMER: 'update-chatroom-customer', // 상담큐, 상담탭 고객정보 동기화
  UPDATE_CUSTOMER_INFO_OPERATION_LEFT: 'update-customer-info-operation-left', // 상담리스트 고객정보 동기화
  UPDATE_CHAT_ROOM_LIST: 'update-chat-room-list', // 탭에 상담방 없을때 리스트 업데이트 (해당 이벤트 버스 제거됨)
  OPEN_CUSTOMER_INFO_TAP: 'open-customer-info-tap', // 고객정보탭으로 이동한다
  ALL_TAB_PICK_CHAT_ROOM: 'pick-chatroom', // 전체탭에서 상담을 픽한다
  UPDATE_TAB_CHAT_ROOM_LIST: 'update-tab-chat-room-list', // 탭에 열은 방의 상태가 변하면 업데이트한다 (해당 이벤트 버스 제거됨)
  TAKE_OVER_MESSAGE_CLEAR: 'takeOverMessage-clear', // 이관 메모 초기화
  TAKE_OVER_MESSAGE: 'takeOverMessage', // 이관 메모 세팅
  CHANGE_ORDER_LIST: 'change-order-list', // 주문번호 리스트 변경
  FETCH_MAIL_TEMPLATES: 'fetch-mail-templates', // 메일 템플릿 리스트를 불러올때 호출
  SHOW_LEFT_TAB_ACTIVE: 'show-left-tab-active', // 상담중 탭으로 이동,
  UPDATE_CHAT_ROOM_INPUT: 'update-chat-room-input',
  UPDATE_FINISHED_INFERENCE: 'update-finished-inference' // 추론 완료 상태 업데이트
};



// WEBPACK FOOTER //
// ./src/components/operation/enums/eventType.js